<template>
  <div class="modal-content-ticket">
    <div class="modal-header">
      <h2>Novi podsetnik</h2>
    </div>

    <form class="form--mod" action="post">
      <div id="title-area">
        <label class="col-form-label col-form-label-lg">Naslov</label>
        <input
          v-model="title"
          class="form-control form-control-lg"
          placeholder="Unesite naslov"
          @focus="errorOccurred = false"
        />
      </div>
      <div id="title-area">
        <label class="col-form-label col-form-label-lg">Opis</label>
        <textarea
          v-model="description"
          class="form-control"
          rows="5"
          id="comment"
          placeholder="Unesite opis"
          @focus="errorOccurred = false"
          ref="descriptionArea"
        ></textarea>
      </div>
      <label class="col-form-label col-form-label-lg">Datum podsetnika</label>
      <datetime
        @focus="errorOccurred = false"
        v-model="dateStart"
        type="datetime"
        input-class="form-control form-control-lg"
        placeholder="Izaberite datum podsetnika
        "
        hidden-name="webstorm"
        value-zone="UTC+1"
        format="dd.MM.yyyy. HH:mm"
        :phrases="{
          ok: 'U redu',
          cancel: 'Otkaži'
        }"
        :min-datetime="minDate"
      ></datetime>
      <div id="title-area" class="contractor-email-wrapper privacy-wrapper">
        <label class="col-form-label col-form-label-lg"
          >Podsetnik se ponavlja
        </label>
        <checkbox
          class="ticket-cb"
          :checked="repeatingReminder"
          @change="repeatingReminder = !repeatingReminder"
        ></checkbox>
      </div>
      <div v-if="repeatingReminder">
        <label class="col-form-label col-form-label-lg">
          Period ponavljanja
        </label>
        <div class="repeat-interval-wrapper">
          <input
            type="number"
            class="form-control repeat-margin"
            @focus="errorOccurred = false"
            v-model="repeatInterval"
          />
          <select
            class="form-control custom-select"
            id="selecCategory"
            v-model="repeatPeriod"
          >
            <option value="day">{{ dayName }}</option>
            <option value="week">{{ weekName }}</option>
            <option value="month">{{ monthName }}</option>
            <option value="year">{{ yearName }}</option>
            >
          </select>
        </div>

        <label
          class="col-form-label col-form-label-lg"
          v-if="repeatPeriod == 'week'"
        >
          Izaberite kojim danima se ponavlja
        </label>
        <div class="radio-group-wrapper">
          <div class="radio-group" v-if="repeatPeriod == 'week'">
            <div
              class="day-checkbox-wrapper"
              :class="{
                'day-checkbox-wrapper-border': day.id != monday && !day.checked
              }"
              v-for="day in weekdays"
              :key="day.id.weekday"
            >
              <input type="checkbox" :id="day.for" v-model="day.checked" />
              <label
                class="radio-label"
                :class="{ 'not-monday': day.id != monday }"
                :for="day.for"
                >{{ day.name }}</label
              >
            </div>

            <!-- <input type="checkbox" id="tue" value="tue" />
            <label class="radio-label not-monday" for="tue">Uto</label>
            <input type="checkbox" id="wed" value="wed" />
            <label class="radio-label not-monday" for="wed">Sre</label>
            <input type="checkbox" id="thu" value="thu" />
            <label class="radio-label not-monday" for="thu">Čet</label>
            <input type="checkbox" id="fri" value="fri" />
            <label class="radio-label not-monday" for="fri">Pet</label>
            <input type="checkbox" id="sat" value="sat" />
            <label class="radio-label not-monday" for="sat">Sub</label>
            <input type="checkbox" id="sun" value="sun" />
            <label class="radio-label not-monday" for="sun">Ned</label> -->
          </div>
        </div>
        <label class="col-form-label col-form-label-lg">
          Završava se
        </label>
        <div class="ends-on-wrapper">
          <input type="radio" name="data" value="date" v-model="endsType" />
          <label for="date">na datum</label>
          <datetime
            @focus="errorOccurred = false"
            v-model="dateUntil"
            type="datetime"
            input-class="form-control form-control-lg"
            placeholder="Izaberite datum"
            hidden-name="webstorm"
            value-zone="UTC+1"
            format="dd.MM.yyyy. HH:mm"
            :phrases="{
              ok: 'U redu',
              cancel: 'Otkaži'
            }"
            :min-datetime="dateStart"
            :disabled="endsType != 'date'"
          ></datetime>
        </div>
        <div class="ends-on-wrapper">
          <input
            type="radio"
            name="data"
            value="occurence"
            v-model="endsType"
          />
          <label for="date">nakon</label>
          <input
            type="number"
            class="form-control form-control-lg"
            placeholder="10"
            @focus="errorOccurred = false"
            :disabled="endsType != 'occurence'"
            v-model="repeatCount"
          />
          <span>ponavljanja</span>
        </div>
      </div>
      <div id="title-area">
        <label class="col-form-label col-form-label-lg">
          Infrastruktura
        </label>
        <model-select
          ref="municipality"
          :options="infrastructures"
          v-model="selectedInfrastructure"
          placeholder="
            Izaberite infrastrukturu"
          class="muni-dropdown add-member-dropdown"
          @input="onInfraChange"
        ></model-select>
        <label class="col-form-label col-form-label-lg">
          Serviser
        </label>
        <model-select
          ref="municipality"
          :options="contractors"
          v-model="selectedContractor"
          placeholder="
            Izaberite servisera"
          class="muni-dropdown add-member-dropdown"
          @input="onContractorChange"
        ></model-select>
        <p v-if="recomendedContractors.length != 0">
          <span v-if="recomendedContractors.length > 1">Predloženi </span>
          <span v-else>Predložen </span>
          <span v-if="recomendedContractors.length > 1">serviseri: </span>
          <span v-else>serviser: </span>
          <span
            v-for="(contractor, index) in recomendedContractors"
            :key="index"
          >
            <span
              class="recomended-contractor"
              @click="selectRecomendedContractor(contractor)"
              >{{ contractor.text }}</span
            >
          </span>
        </p>
        <label class="col-form-label col-form-label-lg">
          Kontakt osoba
        </label>
        <model-select
          ref="municipality"
          :options="contractorContacts"
          v-model="selectedContact"
          placeholder="
            Izaberite kontakt osobu"
          class="muni-dropdown add-member-dropdown"
        ></model-select>
      </div>
      <div id="title-area" class="contractor-email-wrapper privacy-wrapper">
        <label class="col-form-label col-form-label-lg"
          >Podseti putem email-a
          <div class="custom-tooltip">
            <i class="fas fa-info-circle"></i>
            <span class="tooltiptext"
              >Kad se izvrši podsetnik biće Vam poslato email obaveštenje.</span
            >
          </div>
        </label>

        <checkbox
          class="ticket-cb"
          :checked="notifyViaEmail"
          @change="notifyViaEmail = !notifyViaEmail"
        ></checkbox>
      </div>
      <div id="title-area" class="contractor-email-wrapper privacy-wrapper">
        <label class="col-form-label col-form-label-lg"
          >Napravi tiket
          <div class="custom-tooltip">
            <i class="fas fa-info-circle"></i>
            <span class="tooltiptext"
              >Kad se izvrši podsetnik biće kreiran tiket</span
            >
          </div>
        </label>

        <checkbox
          class="ticket-cb"
          :checked="createTicket"
          @change="toggleCreateTicket()"
        ></checkbox>
      </div>
      <div id="title-area" class="contractor-email-wrapper">
        <label class="col-form-label col-form-label-lg"
          >Prosledi tiket serviseru
          <div class="custom-tooltip">
            <i class="fas fa-info-circle"></i>
            <span class="tooltiptext"
              >Tiket će biti poslat serviseru na email</span
            >
          </div>
        </label>
        <checkbox
          class="ticket-cb"
          :checked="sendToContractor"
          :disabled="!selectedContractor || !createTicket"
          @change="sendToContractor = !sendToContractor"
        ></checkbox>
      </div>
    </form>

    <hr />
    <div class="footer">
      <div class="error">
        <transition enter-active-class="animated shake">
          <p class="err-msg" v-if="errorOccurred">{{ errorMessage }}</p>
        </transition>
      </div>

      <div class="buttons" style="text-align:center">
        <button
          type="submit"
          class="btn btn-danger btn--mod"
          @click="closeModal"
        >
          Otkaži
        </button>
        <button
          type="submit"
          class="btn btn-primary btn--mod"
          @click="submitReminder"
          :disabled="loading"
        >
          <span v-if="!loading">Sačuvaj</span>
          <spinner line-fg-color="#00796b" v-if="loading" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex';
import axios from '@/axios/axios';
import { ModelSelect } from 'vue-search-select';
import checkbox from '@/components/common/Checkbox';
import { Datetime } from 'vue-datetime';
import { DateTime } from 'luxon';
import { RRule } from 'rrule';

export default {
  components: {
    ModelSelect,
    checkbox,
    Datetime
  },
  computed: {
    ...mapState(['loading']),
    dayName() {
      if (this.repeatInterval == 1) {
        return 'dan';
      } else {
        return 'dana';
      }
    },
    weekName() {
      if (this.repeatInterval == 1) {
        return 'nedelju';
      } else {
        if (this.repeatInterval != 1 && this.repeatInterval < 5) {
          return 'nedelje';
        } else {
          return 'nedelja';
        }
      }
    },
    monthName() {
      if (this.repeatInterval == 1) {
        return 'mesec';
      } else {
        if (this.repeatInterval != 1 && this.repeatInterval < 5) {
          return 'meseca';
        } else {
          return 'meseci';
        }
      }
    },
    yearName() {
      if (this.repeatInterval == 1) {
        return 'godinu';
      } else {
        if (this.repeatInterval != 1 && this.repeatInterval < 5) {
          return 'godine';
        } else {
          return 'godina';
        }
      }
    }
  },
  data() {
    return {
      errorOccurred: false,
      errorMessage: '',
      contractors: [],
      selectedContractor: null,
      contractorContacts: [],
      selectedContact: null,
      infrastructures: [],
      selectedInfrastructure: null,
      recomendedContractors: [],
      createTicket: false,
      sendToContractor: false,
      contractorContactsAllData: [],
      dateStart: new Date().toISOString(),
      minDate: new Date().toISOString(),
      repeatingReminder: false,
      repeatPeriod: 'day',
      endsType: 'date',
      notifyViaEmail: false,
      title: '',
      description: '',
      dateUntil: null,
      repeatCount: 10,
      repeatInterval: 1,
      weekdays: [
        {
          id: RRule.MO,
          for: 'mon',
          name: 'Pon',
          checked: false
        },
        {
          id: RRule.TU,
          for: 'tue',
          name: 'Uto',
          checked: false
        },
        {
          id: RRule.WE,
          for: 'wed',
          name: 'Sre',
          checked: false
        },
        {
          id: RRule.TH,
          for: 'thu',
          name: 'Čet',
          checked: false
        },
        {
          id: RRule.FR,
          for: 'fri',
          name: 'Pet',
          checked: false
        },
        {
          id: RRule.SA,
          for: 'sat',
          name: 'Sub',
          checked: false
        },
        {
          id: RRule.SU,
          for: 'sun',
          name: 'Ned',
          checked: false
        }
      ],
      monday: RRule.MO
    };
  },
  async created() {
    const contractorsResult = await this.getAllContractors(false);
    this.contractors = contractorsResult.map(cat => {
      cat.value = cat;
      cat.text = cat.name;
      return {
        value: cat,
        text: cat.name
      };
    });
    const response = await axios.get(
      `/community/${
        this.$store.getters.getActiveCommunity.id
      }/infrastructures-with-contractors`
    );
    this.infrastructures = response.data.data.map(infra => {
      infra.value = infra;
      infra.text = infra.name;
      return {
        value: infra,
        text: infra.name
      };
    });
  },
  methods: {
    ...mapMutations(['loadingStarted', 'loadingFinished']),
    ...mapActions('table', ['getAllContractors', 'getCommunityReminders']),
    ...mapMutations('modal', ['closeModal']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),

    toggleCreateTicket() {
      this.createTicket = !this.createTicket;
      if (!this.createTicket) {
        this.sendToContractor = false;
      }
    },
    async onContractorChange() {
      try {
        if (
          this.selectedContractor &&
          (this.selectedContractor.id || this.selectedContractor.value.id)
        ) {
          let contractorId = null;
          if (this.selectedContractor.id) {
            contractorId = this.selectedContractor.id;
          } else {
            contractorId = this.selectedContractor.value.id;
          }
          const result = await axios.get(`/contractor/${contractorId}`);
          this.contractorContactsAllData = result.data.contractor.contacts;
          this.contractorContacts = result.data.contractor.contacts.map(con => {
            return {
              text: `${con.name} (${con.phone})`,
              value: con.id
            };
          });
        } else {
          this.selectedContractor = null;
          this.sendToContractor = false;
          this.selectedContact = null;
        }
      } catch (error) {
        this.selectedContractor = null;
        this.sendToContractor = false;
        this.selectedContact = null;
      }
    },
    onInfraChange() {
      if (
        this.selectedInfrastructure.id ||
        this.selectedInfrastructure.value.id
      ) {
        this.recomendedContractors = [];
        let selectedInfra = null;
        if (this.selectedInfrastructure.id) {
          selectedInfra = this.selectedInfrastructure;
        } else {
          selectedInfra = this.selectedInfrastructure.value;
        }
        for (const [
          index,
          contractorId
        ] of selectedInfra.contractors.entries()) {
          const contractor = this.contractors.find(
            c => c.value.id == contractorId
          );
          if (contractor) {
            if (index == selectedInfra.contractors.length - 1) {
              this.recomendedContractors.push({
                text: contractor.text,
                value: contractor.value
              });
            } else {
              this.recomendedContractors.push({
                text: contractor.text + ', ',
                value: contractor.value
              });
            }
          }
        }
      }
    },
    selectRecomendedContractor(contractor) {
      this.selectedContractor = contractor;
      this.onContractorChange();
    },
    validateInput() {
      if (this.title === '') {
        this.errorMessage = 'Morate uneti naziv podsetnika';
        return false;
      }
      if (this.description === '') {
        this.errorMessage = 'Morate uneti opis podsetnika';
        return false;
      }
      if (DateTime.fromISO(this.dateStart) < DateTime.local()) {
        this.errorMessage = 'Datum početka ne sme biti u prošlosti';
        return false;
      }
      if (this.repeatingReminder && this.repeatInterval < 1) {
        this.errorMessage = 'Podsetnik sme da se ponavlja manje od jednog puta';
        return false;
      }
      if (
        this.repeatingReminder &&
        this.endsType == 'date' &&
        (this.dateUntil == null || this.dateUntil == '')
      ) {
        this.errorMessage = 'Morate uneti datum završetka';
        return false;
      }
      if (
        this.repeatingReminder &&
        DateTime.fromISO(this.dateStart) > DateTime.fromISO(this.dateUntil)
      ) {
        this.errorMessage = 'Datum početka ne može biti nakon datuma završetka';
        return false;
      }
      if (this.sendToContractor && !this.selectedContact) {
        this.errorMessage =
          'Morate izabrati kontakt servisera na koji će biti prosleđen tiket';
        return false;
      }
      if (this.sendToContractor && this.selectedContact) {
        const contact = this.contractorContactsAllData.find(
          c => c.id == this.selectedContact
        );
        if (contact && !contact.email) {
          this.errorMessage =
            'Morate izabrati kontakt servisera koji ima email';
          return false;
        }
      }
      return true;
    },
    createRRule() {
      if (!this.repeatingReminder) {
        const rrule = new RRule({
          count: 1,
          interval: 1,
          freq: RRule.YEARLY
        });
        return rrule.toString().replace('RRULE:', '');
      }
      let rrule;
      let rruleRepeatFrequency;
      switch (this.repeatPeriod) {
        case 'day':
          rruleRepeatFrequency = RRule.DAILY;
          break;
        case 'week':
          rruleRepeatFrequency = RRule.WEEKLY;
          break;
        case 'month':
          rruleRepeatFrequency = RRule.MONTHLY;
          break;
        case 'year':
          rruleRepeatFrequency = RRule.YEARLY;
          break;
      }
      if (this.repeatPeriod == 'week') {
        const selectedWeekdays = this.weekdays
          .map(d => (d.checked ? d.id : null))
          .filter(d => d != null);
        if (this.endsType == 'date') {
          const endDate = DateTime.fromISO(this.dateUntil);
          rrule = new RRule({
            freq: rruleRepeatFrequency,
            wkst: RRule.MO,
            byweekday: selectedWeekdays,
            interval: this.repeatInterval,
            until: new Date(
              Date.UTC(
                endDate.year,
                endDate.month - 1,
                endDate.day,
                endDate.hour,
                endDate.minute
              )
            )
          });
        } else {
          rrule = new RRule({
            freq: rruleRepeatFrequency,
            wkst: RRule.MO,
            byweekday: selectedWeekdays,
            interval: this.repeatInterval,
            count: this.repeatCount
          });
        }
        return rrule.toString().replace('RRULE:', '');
      }
      if (this.endsType == 'date') {
        const endDate = DateTime.fromISO(this.dateUntil);
        rrule = new RRule({
          freq: rruleRepeatFrequency,
          wkst: RRule.MO,
          interval: this.repeatInterval,
          until: new Date(
            Date.UTC(
              endDate.year,
              endDate.month,
              endDate.day,
              endDate.hour,
              endDate.minute
            )
          )
        });
      } else {
        rrule = new RRule({
          freq: rruleRepeatFrequency,
          wkst: RRule.MO,
          interval: this.repeatInterval,
          count: this.repeatCount
        });
      }
      return rrule.toString().replace('RRULE:', '');
    },
    async submitReminder() {
      this.errorOccurred = false;
      if (!this.validateInput()) {
        this.errorOccurred = true;
        return;
      }
      this.loadingStarted();
      let rruleString = this.createRRule();
      if (this.repeatingReminder && this.endsType == 'date') {
        rruleString = rruleString.slice(0, -1);
      }
      try {
        let contractorId = null;
        if (this.selectedContractor) {
          if (this.selectedContractor.value) {
            contractorId = this.selectedContractor.value.id;
          } else {
            contractorId = this.selectedContractor.id;
          }
        }
        let contractorContactId = null;
        if (this.selectedContact) {
          contractorContactId = this.selectedContact;
        }
        let communityInfrastructureId = null;
        if (this.selectedInfrastructure) {
          communityInfrastructureId = this.selectedInfrastructure.id;
        }
        const postData = {
          title: this.title,
          description: this.description,
          createTicket: this.createTicket ? 1 : 0,
          notifyViaMail: this.notifyViaEmail ? 1 : 0,
          rrule: rruleString,
          startDate: DateTime.fromISO(this.dateStart).toFormat(
            'yyyy-MM-dd HH:mm:ss'
          ),
          communityId: this.$store.getters.getActiveCommunity.id,
          contractorId: contractorId,
          contractorContactId: contractorContactId,
          communityInfrastructureId: communityInfrastructureId,
          forwardToContractor: this.sendToContractor ? 1 : 0
        };
        await axios.post('/reminder', postData);
        const currentDate = DateTime.local();
        await this.getCommunityReminders({
          communityId: this.$store.getters.getActiveCommunity.id,
          filters: {
            dateTo: currentDate
              .set({ year: currentDate.year + 1 })
              .toFormat('yyyy-MM-dd')
          }
        });
        this.loadingFinished();
        this.closeModal();
        this.showSuccessModal();
      } catch (error) {
        this.loadingFinished();
        this.showFailModal();
      }
    }
  }
};
</script>
<style scoped lang="scss">
.repeat-interval-wrapper {
  display: flex;
  align-items: center;
  .repeat-margin {
    margin-right: 24px;
  }
}
.day-checkbox-wrapper {
  display: inline-block;
}
.day-checkbox-wrapper-border {
  border-left: 1px solid var(--primary-color);
}
.ends-on-wrapper {
  display: flex;
  justify-content: left;
  align-items: center;
  margin-bottom: 12px;
  input[type='radio'] {
    width: 20px;
    height: 20px;
  }
  span,
  label {
    margin-left: 12px;
    font-size: 1rem;
  }
  input[type='number'] {
    width: auto;
  }
}
.radio-label {
  color: var(--primary-color);
  display: inline-block;
  cursor: pointer;
  padding: 5px 20px;
  margin-bottom: 0;
  width: 4.5rem;
  text-align: center;
}
input[type='checkbox'] {
  position: absolute;
  visibility: hidden;
  display: none;
}
input[type='checkbox']:checked + label {
  color: white;
  background: var(--primary-color);
}

input[type='checkbox']:checked + .not-monday {
  border-left: solid 1px white;
}

label + input[type='checkbox'] + label {
  border-left: solid 1px var(--primary-color);
}
.radio-group-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: left;
}
.radio-group {
  border: solid 1px var(--primary-color);
  display: inline-block;
  margin-top: 6px;
  margin-bottom: 1rem;
  border-radius: 10px;
  overflow: hidden;
}

form {
  .col-form-label {
    width: auto;
  }
}
.contractor-email {
  label {
    width: auto;
  }
}

//--------------
.upload-more-wrapper {
  width: 100%;
}
input[type='checkbox'] {
  position: absolute;
  visibility: hidden;
  display: none;
}

label {
  display: inline-block;
  margin-bottom: 0;
  width: 9rem;
}
.recomended-contractor {
  color: var(--primary-color);
  // border-bottom: 1px solid var(--primary-color);
  cursor: pointer;
}

.contractor-email-wrapper {
  margin-top: 16px;
  display: flex;
  height: 25px;
  width: 100%;
  label.col-form-label {
    width: 300px;
    display: flex;
    align-items: center;
  }
  .ticket-cb {
    margin: 0 0 0 32px;
  }
}
.privacy-lbl {
  color: var(--primary-color);
  display: inline-block;
  cursor: pointer;
  padding: 5px 20px;
  margin-bottom: 0;
  width: 9rem;
  text-align: center;
}

.radio-group {
  border: solid 1px var(--primary-color);
  /*display: inline-block;*/
  margin-bottom: calc(0.5rem + 1px);
  border-radius: 10px;
  overflow: hidden;
}

#radio-wrapper {
  display: flex;
  position: relative;
  flex-flow: column;
  align-items: center;
  padding-bottom: 25px;

  .private-help {
    position: absolute;
    top: 45px;
    color: var(--primary-color-lighten);
    font-size: 14px;
    padding-top: 8px;
  }
}

textarea.form-control {
  resize: none;
  width: 100%;
  height: 110px;
}
#first-section {
  display: inline-flex;
  height: 100%;
  width: 100%;
}
#upload-area {
  display: block;
  margin-left: 9px;
  width: 34%;
  height: 100%;
}
#uploaded-files {
  border: 1px dotted var(--primary-color);
  border-radius: 0.25rem;
  height: 110px;
  resize: none;
  max-height: 134px;
  overflow-y: auto;
  padding: 5px;
}

.file {
  border-bottom: solid 1px lightgray;
  font-size: 15px;
  width: 100%;
  display: inline-flex;
  vertical-align: center;
  p {
    max-width: 100%;
    margin-bottom: 2px;
  }
}

.del--mod {
  margin-left: auto;
  cursor: pointer;
  color: red;
  top: 4.7em;
  right: 1.7em;
}

.footer {
  display: block;
  width: 100%;
  text-align: center;
}
.buttons {
  display: inline-flex;
  float: right;
}

.error {
  float: left;
  margin-left: 15px;
}

.err-msg {
  text-align: center;
  color: red;
}
</style>
